export type BufferGeometryJson = Record<string, unknown>;

/** Tessellated part geometry from the line item's `file_3djs`: triangle meshes
 *  under `shapes`, CAD edge polylines under `edges`. */
export interface PartModel3d {
	model: {
		shapes: Record<string, BufferGeometryJson>;
		edges: Record<string, BufferGeometryJson>;
	};
}

export function isPartModel3d(value: unknown): value is PartModel3d {
	if (typeof value !== 'object' || value === null) return false;
	const model = (value as { model?: unknown }).model;
	return (
		typeof model === 'object' &&
		model !== null &&
		typeof (model as { shapes?: unknown }).shapes === 'object' &&
		(model as { shapes?: unknown }).shapes !== null
	);
}
